(() => {
  const initialize = (root) => {
    if (root.dataset.syPreviewReady === 'true') return;
    root.dataset.syPreviewReady = 'true';
    const dialog = root.querySelector('[data-sy-preview-dialog]');
    const pages = [...root.querySelectorAll('[data-sy-preview-page]')].slice(0, 4).map((button) => {
      try {
        const url = new URL(button.dataset.previewSrc, location.origin);
        if (url.protocol !== 'https:' || ![location.hostname, 'cdn.shopify.com'].includes(url.hostname) || !/\.(webp|png|jpe?g|avif)$/i.test(url.pathname)) return null;
        return { button, url: url.href, label: button.dataset.previewLabel, width: Number(button.dataset.previewWidth), height: Number(button.dataset.previewHeight) };
      } catch { return null; }
    }).filter(Boolean);
    let opener = null;
    let scrollTop = 0;
    let current = 0;
    let zoom = 1;
    let touchStart = null;
    let observer = null;
    let previousOverflow = '';
    if (dialog && pages.length) {
      const stage = dialog.querySelector('[data-sy-preview-stage]');
      const image = dialog.querySelector('[data-sy-preview-image]');
      const counter = dialog.querySelector('[data-sy-preview-counter]');
      const previous = dialog.querySelector('[data-sy-preview-prev]');
      const next = dialog.querySelector('[data-sy-preview-next]');
      const status = dialog.querySelector('[data-sy-preview-status]');
      const zoomValue = dialog.querySelector('[data-sy-preview-zoom-value]');
      const zoomIn = dialog.querySelector('[data-sy-preview-zoom-in]');
      const zoomOut = dialog.querySelector('[data-sy-preview-zoom-out]');
      const fit = () => {
        if (!dialog.open) return;
        const page = pages[current];
        const ratio = page.width > 0 && page.height > 0 ? page.width / page.height : 612 / 792;
        const base = Math.max(1, Math.min(stage.clientWidth - 32, (stage.clientHeight - 32) * ratio));
        image.style.width = `${Math.round(base * zoom)}px`;
        zoomValue.textContent = `${Math.round(zoom * 100)}%`;
        const focusedControl = document.activeElement;
        zoomOut.disabled = zoom <= 1;
        zoomIn.disabled = zoom >= 3;
        if (zoomOut.disabled && focusedControl === zoomOut) zoomIn.focus({ preventScroll: true });
        if (zoomIn.disabled && focusedControl === zoomIn) zoomOut.focus({ preventScroll: true });
      };
      const displayPage = (index) => {
        if (!Number.isInteger(index) || index < 0 || index >= pages.length) return;
        current = index;
        zoom = 1;
        const page = pages[index];
        image.width = page.width;
        image.height = page.height;
        image.alt = page.label;
        status.textContent = 'Loading sample page...';
        image.src = page.url;
        counter.textContent = `Page ${index + 1} of ${pages.length}`;
        const focusedControl = document.activeElement;
        previous.disabled = index === 0;
        next.disabled = index === pages.length - 1;
        if (previous.disabled && focusedControl === previous) next.focus({ preventScroll: true });
        if (next.disabled && focusedControl === next) previous.focus({ preventScroll: true });
        stage.scrollTo(0, 0);
        fit();
      };
      image.addEventListener('load', () => { status.textContent = ''; fit(); });
      image.addEventListener('error', () => { status.textContent = 'This sample page could not load. Please try again.'; });
      pages.forEach((page, index) => page.button.addEventListener('click', () => {
        opener = page.button;
        scrollTop = window.scrollY;
        previousOverflow = document.documentElement.style.overflow;
        if (!dialog.open) dialog.showModal();
        document.documentElement.style.overflow = 'hidden';
        displayPage(index);
        dialog.querySelector('[data-sy-preview-close]').focus({ preventScroll: true });
      }));
      previous.addEventListener('click', () => displayPage(current - 1));
      next.addEventListener('click', () => displayPage(current + 1));
      dialog.querySelector('[data-sy-preview-close]').addEventListener('click', () => dialog.close());
      zoomIn.addEventListener('click', () => { zoom = Math.min(3, zoom + 0.5); fit(); });
      zoomOut.addEventListener('click', () => { zoom = Math.max(1, zoom - 0.5); fit(); });
      dialog.querySelector('[data-sy-preview-fit]').addEventListener('click', () => { zoom = 1; fit(); stage.scrollTo(0, 0); });
      dialog.addEventListener('keydown', (event) => {
        if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
          event.preventDefault();
          displayPage(current + (event.key === 'ArrowRight' ? 1 : -1));
        }
        if (event.key === 'Escape') { event.preventDefault(); dialog.close(); }
        if (event.key === 'Tab') {
          const controls = [...dialog.querySelectorAll('button:not(:disabled)')];
          const first = controls[0];
          const last = controls.at(-1);
          if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
          else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
        }
      });
      stage.addEventListener('touchstart', (event) => {
        const touch = event.touches.length === 1 && event.touches[0];
        touchStart = touch && zoom === 1 ? { x: touch.clientX, y: touch.clientY } : null;
      }, { passive: true });
      stage.addEventListener('touchend', (event) => {
        if (!touchStart || !event.changedTouches.length) return;
        const x = event.changedTouches[0].clientX - touchStart.x;
        const y = event.changedTouches[0].clientY - touchStart.y;
        touchStart = null;
        if (Math.abs(x) > 50 && Math.abs(x) > Math.abs(y) * 1.5) displayPage(current + (x < 0 ? 1 : -1));
      }, { passive: true });
      dialog.addEventListener('close', () => {
        document.documentElement.style.overflow = previousOverflow;
        image.removeAttribute('src');
        opener?.focus({ preventScroll: true });
        window.scrollTo({ top: scrollTop, behavior: 'instant' });
      });
      observer = new ResizeObserver(fit);
      observer.observe(stage);
    }

    const unload = (event) => {
      if (!event.target.contains(root)) return;
      if (dialog?.open) dialog.close();
      observer?.disconnect();
      document.removeEventListener('shopify:section:unload', unload);
    };
    document.addEventListener('shopify:section:unload', unload);
  };
  const initializeAll = (scope = document) => scope.querySelectorAll('[data-sy-page-preview]').forEach(initialize);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initializeAll());
  else initializeAll();
  document.addEventListener('shopify:section:load', (event) => initializeAll(event.target));
})();
